/** @jsxImportSource @emotion/react */
import * as React from 'react'
import { Box, useTheme, Button, Tooltip } from '@mui/material'
import { Link } from 'react-router-dom'
import { Icon } from '@app/components/Atoms/Icon'
import { thumbnailListItem } from './ArticleCard.style'

const DEFAULT_IMAGE = '/images/pictures/accessibility-marketing.png'

type ContentType = {
  Title?: string
  Icon?: string
  Length?: number
}

export interface GuideCardProps {
  title: string
  description?: string
  contentType?: ContentType
  image?: string | null
  onClick?: React.MouseEventHandler<HTMLDivElement>
  path: string
  className?: string
  icon?: React.ReactNode
  'data-testid'?: string
  is_external?: boolean
  external_link?: string
}

export function ArticleCard({
  title,
  contentType,
  image = DEFAULT_IMAGE,
  path,
  icon,
  onClick,
  is_external,
  external_link,
}: GuideCardProps) {
  const theme = useTheme()
  return (
    <Link
      to={is_external ? { pathname: external_link } : path}
      target={is_external ? '_blank' : '_self'}
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <Box css={thumbnailListItem(theme)} onClick={onClick}>
        <Box className="thumbnail">
          <img className="cover" src={image || DEFAULT_IMAGE} alt={title} />
          <Box className="formatIcon">
            {icon || <Icon iconName={`s3://article`} colour="#fff" />}
          </Box>
        </Box>
        <Box className="label">
          <Box className="format">{contentType?.Title?.toUpperCase()}</Box>
          <Tooltip placement="top" title={title} arrow>
            <Box className="title">{title}</Box>
          </Tooltip>
          <Box className="description">
            {contentType?.Title === 'Video' ? `${contentType?.Length || ''} minutes` : ''}
          </Box>
          <Button className="button">{` View >`}</Button>
        </Box>
      </Box>
    </Link>
  )
}

export default ArticleCard
